export default __webpack_public_path__ + "static/media/eb-pro-wht-2.a0f9c247.png";